export { default } from "./ReportGeneratedText";
